// code-display — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: block;
  }

  .tabs-wrapper {
    margin-bottom: 0;
  }

  .tabs-wrapper[hidden] {
    display: none;
  }

  .code-wrapper {
    position: relative;
  }

  pre {
    margin: 0;
    padding: var(--run-code-padding, var(--run-space-semantic-md));
    background: var(--run-wf-surface);
    color: var(--run-wf-text);
    font-family: var(--run-wf-font-family);
    font-size: var(--run-code-font-size, var(--run-font-size-sm));
    font-weight: 400;
    line-height: var(--run-code-line-height, 1.6);
    border-radius: var(--run-code-radius, var(--run-radius-semantic-card));
    border: 1px dashed var(--run-wf-border);
    overflow-x: auto;
    white-space: pre;
    word-break: normal;
  }

  code {
    font-family: inherit;
    font-size: inherit;
  }

  .token.keyword    { color: var(--run-wf-text); }
  .token.string     { color: var(--run-wf-text); }
  .token.number     { color: var(--run-wf-text); }
  .token.comment    { color: var(--run-wf-border); }
  .token.function   { color: var(--run-wf-text); }
  .token.tag        { color: var(--run-wf-text); }
  .token.attr-name  { color: var(--run-wf-text); }
  .token.attr-value { color: var(--run-wf-text); }

  .line-numbers-rows > span.highlighted {
    background: var(--run-wf-surface-subtle, var(--run-wf-surface));
    display: block;
  }

  .line-numbers .line-numbers-rows {
    color: var(--run-wf-border);
  }

  run-icon-button[part="copy-button"] {
    position: absolute;
    top: var(--run-code-copy-button-offset, var(--run-space-semantic-sm));
    right: var(--run-code-copy-button-offset, var(--run-space-semantic-sm));
  }
`;

export function render(host) {
  const {
    isMultiFramework,
    resolvedFrameworkOrder,
    resolvedFrameworkTabs,
    activeFramework,
    resolvedLanguage,
    showLineNumbers,
    activeCode,
    isCopying,
  } = host;

  const lang = resolvedLanguage || 'html';
  const preClass = `language-${lang}${showLineNumbers ? ' line-numbers' : ''}`;
  const codeClass = `language-${lang}`;
  const copyLabel = isCopying ? 'Copied' : 'Copy code';
  const copyIcon = isCopying ? 'check' : 'copy';

  // run-tabs uses the panel attribute on run-tab to identify each tab by name.
  // active="" on run-tabs sets the initially-active panel.
  const tabsHtml = isMultiFramework
    ? `<run-tabs aria-label="Framework" active="${activeFramework}">${
        resolvedFrameworkTabs.map(t =>
          `<run-tab panel="${t.key}"${t.active ? ' active' : ''}>${t.label}</run-tab>`
        ).join('')
      }</run-tabs>`
    : '';

  host.shadowRoot.innerHTML = `
    <run-box class="outer">
      <div class="tabs-wrapper"${isMultiFramework ? '' : ' hidden'}>
        ${tabsHtml}
      </div>
      <div class="code-wrapper">
        <pre class="${preClass}"><code class="${codeClass}">${host.safeHTML(activeCode)}</code></pre>
        <run-icon-button
          part="copy-button"
          label="${copyLabel}"
          icon="${copyIcon}"
        ></run-icon-button>
      </div>
    </run-box>
  `;
}
